/* eslint-disable react-refresh/only-export-components -- context + hook */
import type { AxiosInstance } from 'axios'
import { createContext, useContext, type ReactNode } from 'react'

export type HttpClient = AxiosInstance

const HttpClientContext = createContext<HttpClient | null>(null)

export function useHttpClient(): HttpClient {
  const client = useContext(HttpClientContext)
  if (!client) {
    throw new Error('useHttpClient must be used within HttpClientProvider')
  }
  return client
}

export function HttpClientProvider({
  client,
  children,
}: {
  client: AxiosInstance
  children: ReactNode
}) {
  return (
    <HttpClientContext.Provider value={client}>
      {children}
    </HttpClientContext.Provider>
  )
}
